import React from 'react';
import './DeleteProductDrawer.css';

function DeleteProductDrawer({ isOpen, onClose, onConfirm, productName }) {
  if (!isOpen) return null;

  return (
    <div className="deleteproduct-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div
        className="deleteproduct-popup"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="deleteproduct-header">
          <h3>Delete Product</h3>
        </div>

        <div className="deleteproduct-body">
          <p>
            {productName
              ? <>Are you sure you want to delete <strong>{productName}</strong>? This action cannot be undone.</>
              : 'Are you sure you want to delete this product? This action cannot be undone.'}
          </p>
        </div>

        <div className="deleteproduct-footer">
          <button className="deleteproduct-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="deleteproduct-confirm-btn" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteProductDrawer;
